import React, { useState, useEffect } from 'react';
import fetch from '../@helper/fetch/fetch.js';
import { checAuth } from '../@helper/common/common';
export const Context = React.createContext();

const Store = ({ children }) => {

    const [lastStep, setLastStep] = useState(false);
    const [cardName, setCardName] = useState('');
    const [cardNumber, setCardNumber] = useState('');
    const [expirationDate, setExpirationDate] = useState('');
    const [cvv, setCvv] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [phone, setPhone] = useState('');
    const [auth, setAuth] = useState({ account: '', data: null });
    const [authorized, setAuthorized] = useState(false);
    const [email, setEmail] = useState('');
    const [name, setName] = useState('');
    const [error, setError] = useState({ text: '', type: '', show: false, body: null });
    const [loader, setLoader] = useState(false);


    useEffect(() => {
        if (window.sessionStorage.accessToken) {
            fetch.get('/users/me')
                .then(({ data: { entity } }) => checAuth(entity, setAuth))
                .catch(() => window.sessionStorage.removeItem('accessToken'));

        }
    }, [authorized]);

    const logout = () => {
        fetch.get('/users/me/logout', {})
            .then(() => {
                setAuth({ account: '', data: null });
                setAuthorized(false);
                window.sessionStorage.removeItem('accessToken');
            })
            .catch((err) => {
                setError({ text: err.statusText, type: 'logout', show: true, body: err });
            });
    };



    return (
        <Context.Provider
            value={{
                state: {
                    lastStep,
                    cardName,
                    cardNumber,
                    expirationDate,
                    cvv,
                    postalCode,
                    phone,
                    auth,
                    email,
                    name,
                    error,
                    loader,
                },
                actions: {
                    setLastStep,
                    setCardName,
                    setCardNumber,
                    setExpirationDate,
                    setCvv,
                    setPostalCode,
                    setPhone,
                    setAuth,
                    setEmail,
                    setName,
                    setError,
                    setAuthorized,
                    logout,
                    setLoader
                }
            }}
        >
            {
                children
            }
        </Context.Provider>

    );
};

export default Store;